import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-22527e50"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["innerHTML"];
import { ref, onMounted, watch, onUnmounted } from 'vue';
import { agreementNoEncrypt } from '@/api/informationSafety/agreement';
import { useRouter } from 'vue-router';
import { matchPhone } from '@/utils/tools';
export default /*#__PURE__*/_defineComponent({
  __name: 'PrivacyAgreementNoEncrypt',
  setup(__props) {
    const {
      isIOS
    } = matchPhone();
    const msg = ref('');
    const router = useRouter();
    const isFirst = ref(0);
    // const handleClose = () => {
    //     // router.push({
    //     //     path: '/informationSafety',
    //     // })
    //     router.go(-1)
    // }
    onMounted(() => {
      console.log('onMounted 隐私协议');
      privacy();
    });
    onUnmounted(() => {
      console.info('onUnmounted 隐私协议');
      isFirst.value = 0;
    });
    const privacy = async () => {
      isFirst.value = 1;
      const request = {
        agreeCode: 'privacy'
      };
      const {
        code,
        data,
        message
      } = await agreementNoEncrypt(request);
      if (code === 9000) {
        msg.value = data.authAgreeContent;
      }
    };
    function handlePageShow() {
      console.info('页面pageShow事件触发了 isFirst', isFirst.value);
      if (isFirst.value === 0) {
        privacy();
      }
    }
    function handlePageHide() {
      console.info('页面pageHide事件触发了 isFirst', isFirst.value);
      isFirst.value = 0;
      console.info('赋值 isFirst', isFirst.value);
    }
    const onShow = () => {
      console.info('onShow触发了');
      window.removeEventListener('pageshow', handlePageShow);
      window.removeEventListener('pagehide', handlePageHide);
      window.addEventListener('pageshow', handlePageShow);
      window.addEventListener('pagehide', handlePageHide);
    };
    onShow();
    watch(() => router.currentRoute.value.path, toPath => {
      console.info('监听路由 隐私协议');
      // privacy()
    }, {
      immediate: true,
      deep: true
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", {
        class: "agreement-wrap",
        innerHTML: msg.value
      }, null, 8, _hoisted_1)]);
    };
  }
});